export default {
  listTitle: 'Componentes',
  resizePanel: 'Redimensionar painel de componentes',
  maximizePanel: 'Maximizar painel de componentes',
  minimizePanel: 'Restaurar tamanho do painel de componentes',
};
